import { Outlet } from 'react-router-dom'

import { Header } from '@components/header'
import { BookingHeader } from 'components/booking_header'
import { useMonitoringData } from 'hooks/use_monitoring_data'

export const OfferLayout = () => {
  useMonitoringData()

  return (
    <>
      <Header />
      <BookingHeader />
      <Outlet />
    </>
  )
}
